import { render, staticRenderFns } from "./ConfiguracaoSimplesModal.vue?vue&type=template&id=1c23291c&scoped=true"
import script from "./ConfiguracaoSimplesModal.vue?vue&type=script&lang=js"
export * from "./ConfiguracaoSimplesModal.vue?vue&type=script&lang=js"
import style0 from "./ConfiguracaoSimplesModal.vue?vue&type=style&index=0&id=1c23291c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c23291c",
  null
  
)

export default component.exports